module.exports = __webpack_public_path__ + "static/media/check-3.12ca4902.svg";